var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_86",
    "data-name": "Groupe 86",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.325,
    height: 27.407,
    viewBox: "0 0 31.325 27.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_165",
    "data-name": "Trac\\xE9 165",
    d: "M15.538,2.99a.262.262,0,0,1,.249,0,.286.286,0,0,1,.106.112L29.315,25.939a.342.342,0,0,1,0,.358.319.319,0,0,1-.106.117.227.227,0,0,1-.129.033H2.243a.225.225,0,0,1-.129-.033.319.319,0,0,1-.106-.117.345.345,0,0,1,0-.358L15.432,3.1a.288.288,0,0,1,.106-.112Zm2.044-.881a2.212,2.212,0,0,0-3.837,0L.323,24.947a2.284,2.284,0,0,0,1.918,3.459H29.084A2.284,2.284,0,0,0,31,24.947Z",
    transform: "translate(0 -0.999)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_166",
    "data-name": "Trac\\xE9 166",
    d: "M7,16.856A1.693,1.693,0,1,1,8.7,18.549,1.693,1.693,0,0,1,7,16.856ZM7.168,6.688a1.532,1.532,0,1,1,3.048,0l-.593,5.938a.935.935,0,0,1-1.862,0Z",
    transform: "translate(6.967 3.859)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.af3ab24af759149c8d6d87a11a2c57a5.svg";
export { ForwardRef as ReactComponent };